define("settings/components/downgrade-slide-social-sets", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tDG--slide" data-test-id="downgrade-slide-social-sets">
    <div class="o--modalHeader">
      <p class="o--modalHeader__title">
        {{t "account.downgrade.social_sets.title" count=@overageSocialSets}}
      </p>
      <p class="u--m__tb__xs">
        {{t "account.downgrade.social_sets.subtitle" count=@targetSocialSetCount}}
      </p>
      <Shared::Ui::Button
        @onClick={{@organizeSocialProfiles}}
        @text={{t "account.downgrade.social_sets.organize.link"}}
        @variant="unstyled"
        class="u--m__tb__xs u--p__0 u--text--hl u--text--underline"
      />
    </div>
  
    <div class="o--modalBody u--p__t__0 tDG--scroll__body">
      <div class="o--card u--m__b">
        <table class="o--table o--table--condensed o--table--hover u--m__b__0">
          <thead>
            <tr>
              <th class="u--text--left">
                <p class="u--text--bold u--m__tb__xs">
                  {{t "shared_phrases.social_sets.info.header"}}
                </p>
              </th>
            </tr>
          </thead>
  
          <tbody>
            <div class="tDG--tableScroll tDG--tableScroll--lg u--p__lr__0">
              {{#each @socialSets as |socialSet index|}}
                <tr>
                  <td>
                    <div class="u--row u--p__t__xs">
                      <div class="u--col__8">
                        {{! Social Set }}
                        <Shared::SocialIdentity
                          @clickedDetails={{action (noop)}}
                          @index={{index}}
                          @isDisabled={{if (find-by "id" socialSet.id @socialSetsToRemove) true false}}
                          @socialIdentity={{socialSet}}
                        />
                      </div>
                      {{! Action Btn }}
                      <div class="u--col__4 u--p__t__sm">
                        {{#if (find-by "id" socialSet.id @socialSetsToRemove)}}
                          <Shared::Ui::Button
                            @onClick={{fn @restoreSocialSet socialSet}}
                            @text={{t "account.downgrade.social_sets.restore"}}
                            @variant="outline"
                            class="u--float--right"
                            data-test-id="restore-set"
                          />
                        {{else}}
                          <Shared::Ui::Button
                            @onClick={{fn @removeSocialSet socialSet}}
                            @text={{t "shared_words.delete"}}
                            @variant="outline"
                            class="u--float--right"
                            data-test-id="remove-set"
                          />
                        {{/if}}
                      </div>
                    </div>
                  </td>
                </tr>
              {{/each}}
            </div>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  */
  {
    "id": "tXqAmfuv",
    "block": "[[[10,0],[14,0,\"tDG--slide\"],[14,\"data-test-id\",\"downgrade-slide-social-sets\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--modalHeader\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.social_sets.title\"],[[\"count\"],[[30,1]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--m__tb__xs\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.social_sets.subtitle\"],[[\"count\"],[[30,2]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,1],[[24,0,\"u--m__tb__xs u--p__0 u--text--hl u--text--underline\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,3],[28,[37,0],[\"account.downgrade.social_sets.organize.link\"],null],\"unstyled\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"o--modalBody u--p__t__0 tDG--scroll__body\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--card u--m__b\"],[12],[1,\"\\n      \"],[10,\"table\"],[14,0,\"o--table o--table--condensed o--table--hover u--m__b__0\"],[12],[1,\"\\n        \"],[10,\"thead\"],[12],[1,\"\\n          \"],[10,\"tr\"],[12],[1,\"\\n            \"],[10,\"th\"],[14,0,\"u--text--left\"],[12],[1,\"\\n              \"],[10,2],[14,0,\"u--text--bold u--m__tb__xs\"],[12],[1,\"\\n                \"],[1,[28,[35,0],[\"shared_phrases.social_sets.info.header\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,\"tbody\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"tDG--tableScroll tDG--tableScroll--lg u--p__lr__0\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,4]],null]],null],null,[[[1,\"              \"],[10,\"tr\"],[12],[1,\"\\n                \"],[10,\"td\"],[12],[1,\"\\n                  \"],[10,0],[14,0,\"u--row u--p__t__xs\"],[12],[1,\"\\n                    \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n\"],[1,\"                      \"],[8,[39,4],null,[[\"@clickedDetails\",\"@index\",\"@isDisabled\",\"@socialIdentity\"],[[28,[37,5],[[30,0],[28,[37,6],null,null]],null],[30,6],[52,[28,[37,8],[\"id\",[30,5,[\"id\"]],[30,7]],null],true,false],[30,5]]],null],[1,\"\\n                    \"],[13],[1,\"\\n\"],[1,\"                    \"],[10,0],[14,0,\"u--col__4 u--p__t__sm\"],[12],[1,\"\\n\"],[41,[28,[37,8],[\"id\",[30,5,[\"id\"]],[30,7]],null],[[[1,\"                        \"],[8,[39,1],[[24,0,\"u--float--right\"],[24,\"data-test-id\",\"restore-set\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,9],[[30,8],[30,5]],null],[28,[37,0],[\"account.downgrade.social_sets.restore\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],[[[1,\"                        \"],[8,[39,1],[[24,0,\"u--float--right\"],[24,\"data-test-id\",\"remove-set\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,9],[[30,9],[30,5]],null],[28,[37,0],[\"shared_words.delete\"],null],\"outline\"]],null],[1,\"\\n\"]],[]]],[1,\"                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[5,6]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@overageSocialSets\",\"@targetSocialSetCount\",\"@organizeSocialProfiles\",\"@socialSets\",\"socialSet\",\"index\",\"@socialSetsToRemove\",\"@restoreSocialSet\",\"@removeSocialSet\"],false,[\"t\",\"shared/ui/button\",\"each\",\"-track-array\",\"shared/social-identity\",\"action\",\"noop\",\"if\",\"find-by\",\"fn\"]]",
    "moduleName": "settings/components/downgrade-slide-social-sets.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});